<template>
<div class="banner">
  <h1 class="main-title">{{banner.title}}</h1>
  <div class="sub-title">
    {{banner.sub}}
  </div>
  <!-- <a href="/" class="try-button">了解详情</a> -->
  <div class="foot-title">
    <p class="zh">探索科技的无限可能</p>
    <p class="en">Explore the possibilities of technology</p>
  </div>
  <img :src="banner.img">
</div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      
    }
  },
  props:{
    banner: Object
  },
  computed: {
    
  },
  mounted() {
    
  }
}
</script>

<style scoped lang="less">
.banner{
  margin-top: 72px;
  position: relative;
  img{ 
    width: 100%;
    vertical-align: middle;
  }
  .main-title{
    position: absolute;
    left: 50%;
    width: 100%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    top: 100px;
    font-size: 6.43em;
    font-weight: 700;
    color: #fff;
    letter-spacing: 9px;
    text-align: center;
    margin: 0;
    text-shadow: 0 2px 23px rgba(8,19,29,.77);
  }
  .sub-title {
    position: absolute;
    left: 50%;
    width: 100%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    top: 250px;
    font-size: 2.85em;
    color: #fff;
    letter-spacing: 2.67px;
    text-align: center;
    line-height: 50px;
    text-shadow: 0 2px 23px rgba(8,19,29,.77);
    margin: 1% 0 3.34%;
  }
  .try-button{
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    top: 380px;
    display: block;
    cursor: pointer;
    border: 2px solid #fff;
    border-radius: 4px;
    width: 200px;
    line-height: 50px;
    margin: 0 auto;
    font-size: 18px;
    color: #fff;
    letter-spacing: 1px;
    text-align: center;
    background: 0 0;
    text-decoration: none;
  }
  .foot-title{
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    bottom: 82px;
    .zh {
      font-size: 18px;
      color: #fff;
      text-align: center;
      letter-spacing: 6.34px;
      line-height: 24px;
    }
    .en {
      font-size: 14px;
      color: #fff;
      text-align: center;
      letter-spacing: .32px;
      text-shadow: 0 0 4px rgba(0,0,0,.32);
    }
  }
  @media only screen and (max-width: 1500px) {
      .foot-title {
        display: none;
      }
  }
}
</style>
